import produce from 'immer';
import { handleActions } from 'redux-actions';

import { CAMERAS } from '@/define/camera';

const initialState = {};

export default handleActions(
  {
    'ROBOT_OPTIONS/RESET': (state, action) => initialState,
    'ROBOT_OPTIONS/INIT': (state, action) =>
      produce(state, (draft) => {
        const { robotId } = action.payload;

        draft[robotId] = {
          label: { visible: true },
          trace: { visible: true, type: 'full' },
          photo: {
            visible: true,
            type: 'marker',
            camera: CAMERAS[0],
            focalLength: CAMERAS[0].specs.focalLengths[0],
          },
        };
      }),
    'ROBOT_OPTIONS/REMOVE': (state, action) =>
      produce(state, (draft) => {
        const { robotId } = action.payload;

        delete draft[robotId];
      }),
    'ROBOT_OPTIONS/TOGGLE_VISIBLE': (state, action) =>
      produce(state, (draft) => {
        const { robotId, key } = action.payload;

        draft[robotId][key].visible = !state[robotId][key].visible;
      }),
    'ROBOT_OPTIONS/CHANGE_TRACE_TYPE': (state, action) =>
      produce(state, (draft) => {
        const { robotId, type } = action.payload;

        draft[robotId].trace.type = type;
      }),
    'ROBOT_OPTIONS/CHANGE_PHOTO_TYPE': (state, action) =>
      produce(state, (draft) => {
        const { robotId, type } = action.payload;

        draft[robotId].photo.type = type;
      }),
    'ROBOT_OPTIONS/CHANGE_CAMERA': (state, action) =>
      produce(state, (draft) => {
        const { robotId, name } = action.payload;

        const camera = CAMERAS.find((camera) => camera.name === name);
        draft[robotId].photo.camera = camera;
        draft[robotId].photo.focalLength = camera.specs.focalLengths[0];
      }),
    'ROBOT_OPTIONS/CHANGE_FOCAL_LENGTH': (state, action) =>
      produce(state, (draft) => {
        const { robotId, value } = action.payload;

        draft[robotId].photo.focalLength = value;
      }),
  },
  initialState
);
